import { Box } from '@xstyled/styled-components'

export default Box
